import { method } from "lodash"
import { api } from "shared/redux/api"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    test: build.query({
      query: () => ({
        url: "https://dummyjson.com/products/1",
      }),
    }),
    ssoLogin: build.mutation({
      query: (arg) => ({
        url: "/public/sso/verify-token",
        body: arg,
        method: "POST",
      }),
    }),
    login: build.mutation({
      query: (arg) => ({
        url: "/public/login/v1",
        method: "POST",
        body: arg,
      }),
    }),
    loginV2: build.mutation({
      query: (arg) => ({
        url: "/public/login/v2",
        method: "POST",
        headers: {
          Authorization: `Basic ${arg?.token}`,
        },
      }),
      transformErrorResponse: (response) => {
        if (!response.status && response.data === "Network Error") {
          return {
            status: 503,
            data: "Network Error",
            message:
              "Unable to connect to the server. Please check your internet connection.",
          }
        }
        return response
      },
    }),
    changePassword: build.mutation({
      query: (arg) => ({
        url: "/private/user/v1/changePassword",
        method: "PUT",
        body: arg,
      }),
    }),
    changePasswordV2: build.mutation({
      query: (arg) => ({
        url: "/private/user/v2/changePassword",
        method: "PUT",
        body: arg,
      }),
    }),
    refreshToken: build.mutation({
      query: (arg) => ({
        url: "/public/login/v1/refreshAccessToken",
        method: "POST",
        body: arg,
      }),
    }),
    user: build.query({
      query: () => ({
        url: "/private/user/v1/profile",
      }),
    }),
    changeAvatar: build.mutation({
      query: (arg) => ({
        url: "/private/user/v1/avatar",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data;",
        },
        body: arg,
        formData: true,
      }),
    }),
    sendMailResetPassword: build.mutation({
      query: (arg) => {
        return {
          url: `/public/login/v1/sendMailResetPassword`,
          method: "POST",
          body: arg,
        }
      },
    }),
    resetPassword: build.mutation({
      query: (arg) => {
        return {
          url: `/public/login/v1/resetPassword`,
          method: "PUT",
          body: arg,
        }
      },
    }),
    checkManager: build.query({
      query: (arg) => ({
        url: "/private/user/v1/check-manager",
        params: arg,
      }),
    }),
    getAuthUserCenters: build.query({
      query: () => ({ url: "/private/auth-user/v1/centers" }),
      transformResponse: (response) => (Array.isArray(response?.data) ? response.data : []),
    }),
  }),
  overrideExisting: false,
})

export const {
  useLoginMutation,
  useLoginV2Mutation,
  useChangePasswordMutation,
  useChangePasswordV2Mutation,
  useRefreshTokenMutation,
  useUserQuery,
  useLazyUserQuery,
  useTestQuery,
  useChangeAvatarMutation,
  useSendMailResetPasswordMutation,
  useResetPasswordMutation,
  useSsoLoginMutation,
  useLazyCheckManagerQuery,
  useGetAuthUserCentersQuery,
} = injectedRtkApi
